import { render, staticRenderFns } from "./GoodTableSearch.vue?vue&type=template&id=05b8cb48"
import script from "./GoodTableSearch.vue?vue&type=script&lang=js"
export * from "./GoodTableSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports